import { SessionStorageKey } from "./constants";
import {
  getNoomSessionStorage,
  setNoomSessionStorage,
} from "./noomSessionStorage";

export function getMarketingSmsConsentPrefill(): boolean | undefined {
  const value = getNoomSessionStorage(SessionStorageKey.marketingSmsConsent);

  return typeof value === "boolean" ? value : undefined;
}

export function setMarketingSmsConsentPrefill(value: boolean): void {
  setNoomSessionStorage(SessionStorageKey.marketingSmsConsent, value);
}
